import { features } from '@/lib/features';
import { isUserActionCommit } from '@/lib/globals';

export const getFlowName = (accountType: string): string => {
  if (accountType === 'signup') {
    const isPOMAEligible = features.isActive('isPOMAEligible');
    const isPasswordlessForcedSignup = features.isActive(
      'passwordlessForcedSignup',
    );
    const isStreamlineOptionalSignup = features.isActive(
      'isStreamlineOptionalExperience',
    );

    return (isPOMAEligible || isPasswordlessForcedSignup) &&
      !isStreamlineOptionalSignup
      ? 'poma'
      : 'signup';
  }

  return 'guest';
};

export const getSubFlow = (
  withConversion: boolean,
): 'donate' | 'commit' | 'base' => {
  if (features.isActive('isDonation')) {
    return 'donate';
  }

  // Content is the same as the base content for useraction='commit'
  // when conversion is needed
  const isCommit = !withConversion && isUserActionCommit();

  return isCommit ? 'commit' : 'base';
};
